import React from 'react';

import { Link } from 'react-router-dom';
import { FiExternalLink } from 'react-icons/fi';
import { useLandingPages } from '../../../../hooks';
import DashboardLoader from '../../sections/Loader/DashboardLoader';

const CardWithSwitch = ({
  title = 'Notifications',
  description = 'Enable push notifications to stay updated with the latest alerts.',
  path = '',
}) => (
  <div className='bg-white dark:bg-gray-800 rounded-xl shadow-md p-6 border border-transparent dark:border-gray-700 transition-colors duration-200'>
    <div className='flex items-center justify-between'>
      <h3 className='text-lg font-semibold text-gray-800 dark:text-white'>{title}</h3>

      <Link to={`https://davsafaris.com/${path}`} target='_blank' className='text-gray-400 hover:text-primary-600 dark:hover:text-primary-400 transition-colors'>
        <FiExternalLink />{' '}
      </Link>
    </div>

    {description && <p className='mt-3 text-sm text-gray-500 dark:text-gray-400'>{description}</p>}
  </div>
);

const LandingPages = () => {
  const { loading, pages } = useLandingPages();

  return (
    <div className='w-full md:p-5'>
      <h1 className='text-2xl font-bold my-2 text-gray-900 dark:text-white'>Landing Pages</h1>
      {loading ? (
        <DashboardLoader />
      ) : (
        <div className='grid grid-cols-1 sm:grid-cols-3 gap-4 mt-6'>
          {pages.map((page: any) => (
            <Link to={`https://davsafaris.com/${page.path}`} target='_blank' key={page._id} className='block hover:scale-[1.02] transition-transform duration-200'>
              <CardWithSwitch
                title={page.name}
                description={page.description}
                path={page.path}
              />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default LandingPages;
